"use client";

import { createContext, PropsWithChildren, useContext } from "react";

import type { GeolocationApiResponse } from "@silversea-ssc/dotcom-api-types/Geolocation";

type Context = GeolocationApiResponse;
const GeolocationContext = createContext<Context | undefined>(undefined);

export const GeolocationProvider: React.FC<
  PropsWithChildren<{ value: Context }>
> = ({ children, value }) => {
  return (
    <GeolocationContext.Provider value={value}>
      {children}
    </GeolocationContext.Provider>
  );
};

export const useGeolocation = () => {
  const context = useContext(GeolocationContext);
  if (!context) {
    throw new Error("useGeolocation must be used within a GeolocationProvider");
  }
  return context;
};
